import React, { Component } from 'react'
import GenericEvent from './GenericEvent'
import { getNormalizedTagColor } from 'utils/TagAppearanceHelper'

const TAG_ICON_SRC = require('images/svg/tag-navy.svg')

export default class TagEvent extends Component {
  static defaultProps = {
    author: { name: 'Drift' }
  }

  render() {
    const { eventType } = this.props.event
    const { tag, author } = this.props.event.body
    const eventLabel = (eventType === 'TAG_REMOVE' ? 'removed tag from this contact' : 'added tag to this contact')
    const eventProps = {
      actionTaker: author,
      iconSrc: TAG_ICON_SRC,
      eventLabel,
      ...this.props
    }
    return (
      <GenericEvent {...eventProps }>
        <div className="tag" style={{
          backgroundColor: `#${getNormalizedTagColor(tag.color)}`,
          color: 'var(--main-navy-extra-dark)',
        }}>{tag.name}</div>
      </GenericEvent>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/TagEvent.js